import {request} from '@/utils/request'

const prefix = '/app/ports'

export function fetchAll () {
  return request({
    url: `${prefix}/fetchAll`,
    method: 'get'
  })
}

export function search (query, maxResults = null) {
  return request({
    url: `${prefix}/search?query=` + encodeURI(query) + (maxResults != null ? `&maxResults=${maxResults}` : ''),
    method: 'get'
  })
}

export function addGeopoint (code, name) {
  return request({
    url: `${prefix}/add-geopoint`,
    method: 'post',
    data: {
      code, name
    }
  })
}



// WEBPACK FOOTER //
// ./src/rest/freight/ports.js